import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@teach/ui'
import type { Course } from '@/types/course'
import { courseDisplayName } from '@/lib/localizedText'
import { useLanguage } from '@/hooks/useLanguage'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  course: Course | null
  onCancel: () => void
  onConfirm: () => void
}

export const DeleteCourseDialog = ({ course, onCancel, onConfirm }: Props) => {
  const { language } = useLanguage()
  const m = useMessages(messages)
  // Находка 6: `course?.name ?? 'Курс'` игнорировал nameEn — англоязычный
  // курс (name=null) подтверждался безымянным. courseDisplayName даёт
  // симметричный фолбэк с тем же дефолтом на случай, когда пусты оба слота.
  const name = course ? courseDisplayName(course, language) : m.courseFallback

  return (
    <AlertDialog open={!!course} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent className="bg-surface border-border max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[15px] text-white">{m.deleteTitle}</AlertDialogTitle>
          <AlertDialogDescription className="text-[13px] text-foreground/50">
            {m.deleteDescription(name)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="h-8 px-3 text-[13px]">{m.cancel}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="h-8 px-3 text-[13px] bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {m.delete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
